module.exports = __webpack_public_path__ + "img/button.44b095be.png";